<script>
  import { modal } from 'vue-strap';

  export default {
    components: { modal },
    props: ['mostrar', 'id', 'salvando', 'observacao'],
    data() {
      return {
        confirmando: false,
      }
    },
    methods: {
      confirmar() {
        this.confirmando = true;
      }
    },
    computed: {
      show() {        
        this.confirmando = false;
        return this.mostrar;
      },
    }
  }
</script>

<template>
  <div>
    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="$emit('fechado')"
           :backdrop="!salvando">
      <div slot="modal-header" class="modal-header hide"></div>

      <div class="swal2-icon swal2-question" style="display: block;">!</div>

      <h3 class="text-center">
        {{this.observacao}}
      </h3>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" style="margin-bottom: 5px;" @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalObservacaoCompra.vue